import * as yup from 'yup';
import _get from 'lodash/get';
import {
	Row,
	RenderConfig,
	TextInput,
	AssetUploadInput,
	ASSET_TYPE,
	SelectInput,
	EMPTY_ARRAY,
	BOOLEAN_OPTIONS,
	Column,
	AsyncSelect,
	NumberInput
} from 'commons-ui';

export const FORM_FIELD_KEYS = {
	CSV_NAME: 'csvName',
	DESCRIPTION: 'description',
	CSV_URL: ASSET_TYPE.CSV,
	TYPE_BUCKET: 'typeBucket',
	TITLE: 'title',
	SUBTITLE: 'subtitle',
	TXN_MESSAGE: 'txnMessage',
	COMMON_TRANSACTION_MESSAGE: 'commonTransactionMessage',
	TXN_HEADING: 'txnHeading',
	DEVICE_TYPE: 'deviceType', // andorid or all(null),
	SEND_INAPP_NOTIFACTION: 'sendInAppNotificationAlso',
	BONUS_EXPIRY: 'BonusExpiry'
};

const txnMessageDependencyResolver = (props: any, dependencies: any) => {
	const isCommonTxnMessage = _get(dependencies, '0');
	if (isCommonTxnMessage) {
		return { hidden: false };
	}
	return { hidden: true };
};

const txnHeadingDependencyResolver = (props: any, dependencies: any) => {
	const txnNumber = _get(dependencies, '0');
	if (txnNumber === 'TYPE_MISCELLANEOUS') {
		return { hidden: false };
	}
	return { hidden: true };
};

const DEVICE_TYPE_OPTIONS = [
	{
		id: 'android',
		label: 'Android'
	}
];

export const validationSchema = yup.object().shape({
	csvName: yup.string().required('CSV Name is a required field'),
	description: yup.string().required('Description is a required field'),
	csv: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	}),
	title: yup.string().required('Title is required'),
	subtitle: yup.string().required('Subtitle is required'),
	typeBucket: yup.string().required('Bucket type is reqd'),
	deviceType: yup.string().required('Device type is reqd'),
	sendInAppNotificationAlso: yup.boolean().required('Send In app notif is required')
});

const bucketoption = [
	{ id: 'TYPE_MISCELLANEOUS', label: 'TYPE_MISCELLANEOUS' },
	{ id: 'TYPE_REFERRAL_FIRST_PAYMENT_AWARD', label: 'TYPE_REFERRAL_FIRST_PAYMENT_AWARD' }
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.CSV_NAME]: new RenderConfig()
		.setName('csvName')
		.setLabel('CSV Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),

	[FORM_FIELD_KEYS.TITLE]: new RenderConfig()
		.setName('title')
		.setLabel('Notification Title')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),

	[FORM_FIELD_KEYS.SUBTITLE]: new RenderConfig()
		.setName('subtitle')
		.setLabel('Notification Subtitle')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),

	[FORM_FIELD_KEYS.TXN_HEADING]: new RenderConfig()
		.setName('txnHeading')
		.setLabel('Transaction Heading')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			dependencyResolver: txnHeadingDependencyResolver,
			isHidden: { create: true },
			dependencies: ['typeBucket']
		}),

	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.CSV_URL]: new RenderConfig()
		.setName(ASSET_TYPE.CSV)
		.setLabel('Upload CSV File')
		.setRenderer(AssetUploadInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			assetType: ASSET_TYPE.CSV,
			downloadFile: true,
			displayText: 'Sample CSV For type 26',
			link: 'https://zupee-common-test-bucket.s3.ap-south-1.amazonaws.com/prod/new%2Bbonus%2Bto%2Bhigh%2Brollers%2B-%2BSheet.csv'
		}),
	[FORM_FIELD_KEYS.TYPE_BUCKET]: new RenderConfig()
		.setName('typeBucket')
		.setLabel('Transaction Type')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: false }, options: bucketoption, required: true }),
	[FORM_FIELD_KEYS.TXN_MESSAGE]: new RenderConfig()
		.setName('txnMessage')
		.setLabel('Transaction Message')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			dependencies: ['commonTransactionMessage'],
			dependencyResolver: txnMessageDependencyResolver,
			isHidden: { create: true }
		}),
	[FORM_FIELD_KEYS.COMMON_TRANSACTION_MESSAGE]: new RenderConfig()
		.setName('commonTransactionMessage')
		.setLabel(
			'Common transaction message for all rows in csv? (If you select it true, you cannot enter txnMessage column in the csv otherwise you have to add it)'
		)
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: 'boolean',
			required: true,
			options: BOOLEAN_OPTIONS
		}),
	[FORM_FIELD_KEYS.SEND_INAPP_NOTIFACTION]: new RenderConfig()
		.setName('sendInAppNotificationAlso')
		.setLabel('Send in-app notifications?')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: BOOLEAN_OPTIONS
		}),
	[FORM_FIELD_KEYS.DEVICE_TYPE]: new RenderConfig()
		.setName('deviceType')
		.setLabel('Device Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: DEVICE_TYPE_OPTIONS
		}),
	[FORM_FIELD_KEYS.BONUS_EXPIRY]: new RenderConfig()
		.setName('bonusExpiry')
		.setLabel('Bonus Expiry In Hours')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.CSV_NAME),
	new Row(FORM_FIELD_KEYS.DESCRIPTION),
	new Row(FORM_FIELD_KEYS.TYPE_BUCKET),
	new Row(FORM_FIELD_KEYS.TXN_HEADING),

	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.TITLE)]), new Column([new Row(FORM_FIELD_KEYS.SUBTITLE)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.DEVICE_TYPE)]),
		new Column([new Row(FORM_FIELD_KEYS.SEND_INAPP_NOTIFACTION)])
	]),
	new Row(FORM_FIELD_KEYS.COMMON_TRANSACTION_MESSAGE),
	new Row(FORM_FIELD_KEYS.TXN_MESSAGE),
	new Row(FORM_FIELD_KEYS.BONUS_EXPIRY),
	new Row(FORM_FIELD_KEYS.CSV_URL)
];
